import { Space } from 'antd'
import DisabledRelationsPanel from './DisabledRelationsPanel'
import DisabledTypesPanel from './DisabledTypesPanel'
import DevtoolsPanel from './DevtoolsPanel'
import GraphConfigPanel from './GraphConfigPanel'
import IdFormattingPanel from './IdFormattingPanel'
import MemberKeyPanel from './MemberKeyPanel'
import NameKeysPanel from './NameKeysPanel'
import NamespacesPanel from './NamespacesPanel'
import OpenDefaultViewPanel from './OpenDefaultViewPanel'
import RelationLabelsPanel from './RelationLabelsPanel'
import ThemePanel from './ThemePanel'
import UserMode from './UserMode'

export default Data = ->
  <Space
    size={20}
    direction="vertical"
    style={{ padding: '20px 60px 20px 20px' }}
  >
    <h1>{ Weaver.getInstance().currentProject()?.name() }</h1>
    <UserMode />
    <OpenDefaultViewPanel />
    <MemberKeyPanel />
    <NameKeysPanel />
    <GraphConfigPanel />
    <IdFormattingPanel />
    <NamespacesPanel />
    <RelationLabelsPanel data-testid="relation-labels-panel"/>
    <DisabledRelationsPanel />
    <DisabledTypesPanel />
    <DevtoolsPanel />
    <ThemePanel />
  </Space>
